import React from "react";
import { Routes, Route } from "react-router-dom";
import RegisterStepTwo from "./pages/register/RegisterStepTwo";
import RegisterStepOne from "./pages/register/RegisterStepOne";
import NewHome from "./pages/newhome/NewHome";
import Login from "./pages/login/Login";
import UserProfile from './pages/user/UserProfile';
import UserBalance from './pages/user/UserBalance';
import RequestPasswordReset from './pages/password-reset/RequestPasswordReset';
import AdminView from "./pages/admin/AdminView";
import AdminLogs from "./pages/admin/AdminLogs";
import AdminBalance from "./pages/admin/AdminBalance";
import AdminUsers from './pages/admin/AdminUsers';
import AdminPartners from './pages/admin/AdminPartners';
import AdminAudit from './pages/admin/AdminAudit';
import AccessDenied from "./pages/access-denied/AccessDenied";
import UserSettings from "./pages/user/UserSettings";
import ProtectedRoute from "./components/ProtectedRoute";
import UserProtectedRoute from "./components/UserProtectedRoute";
import UpdateInsurance from "./pages/register/UpdateInsurance";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/register-step-one" element={<RegisterStepOne />} />
      <Route path="/register-step-two" element={<RegisterStepTwo />} />
      <Route path="/update-insurance" element={<UpdateInsurance />} />
      <Route path="/newhome" element={<ProtectedRoute><NewHome /></ProtectedRoute>} />
      <Route path="/login" element={<Login />} />
      <Route path="/profile" element={<UserProtectedRoute><UserProfile /></UserProtectedRoute>} />
      <Route path="/user-home" element={<UserProtectedRoute><UserBalance /></UserProtectedRoute>} />
      <Route path="/reset_password" element={<RequestPasswordReset />} />
      <Route path="/admin/view" element={<ProtectedRoute><AdminView /></ProtectedRoute>} />
      <Route path="/admin/logs" element={<ProtectedRoute><AdminLogs /></ProtectedRoute>} />
      <Route path="/admin/balance" element={<ProtectedRoute><AdminBalance /></ProtectedRoute>} />
      <Route path="/admin/users" element={<ProtectedRoute><AdminUsers /></ProtectedRoute>} />
      <Route path="/admin/partners" element={<ProtectedRoute><AdminPartners /></ProtectedRoute>} />
      <Route path="/admin/audit" element={<ProtectedRoute><AdminAudit /></ProtectedRoute>} />
      <Route path="/access-denied" element={<AccessDenied />} />
      <Route path="/user-settings" element={<UserProtectedRoute><UserSettings /></UserProtectedRoute>} />
      <Route path="*" element={<AccessDenied />} />
    </Routes>
  );
}

export default App;
